import dayjs from 'dayjs';
import {
  AsyncActionState,
  asyncActionStateMatchers,
  setupSlice,
  invoke,
} from '@owl-frontend/redux';
import { fetchActivities } from '../../api/activities/client';
import type { Activity } from '../../api/activities/interface';

export interface ActivitiesState {
  activities: {
    [dossier_id: string]: Activity[];
  };
  actions: {
    fetchActivities: AsyncActionState<Activity[]>;
  };
}

const initialState: ActivitiesState = {
  activities: {},
  actions: {
    fetchActivities: { status: 'uninitialized' },
  },
};

const slice = setupSlice('activities', initialState)
  .addAsyncSagas({
    fetchActivities: invoke(fetchActivities),
  })
  .addReducers({
    'fetchActivities/fulfilled': (state, action) => {
      state.activities[action.meta.arg] = action.payload.sort((a, b) => {
        return (
          dayjs(b?.data?.activity_completion_date).valueOf() -
          dayjs(a?.data?.activity_completion_date).valueOf()
        );
      });
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
